module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v22c0 1.106.894 2 2 2h12v2h-4c-1.106 0-2 .894-2 2s.894 2 2 2h12c1.106 0 2-.894 2-2s-.894-2-2-2h-4v-2h12c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2 22H4V4h24v18zM9 12h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1zm0 6h14a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/computer-1.js
// module id = 1088
// module chunks = 14